module.exports = __webpack_public_path__ + "static/media/Candidate14.6636852d.png";